export const fourBreadcrumbsList = {
    'addOrder': [
        '/authorPurchase',
        '/addOrder'
    ],
    'fatherDetails': [
        '/authorPurchase',
        '/fatherDetails'
    ],
    'childDetails': [
        '/authorPurchase',
        '/childDetails'
    ],
    'addPurchaseOrder': [
        '/authorPurchase',
        '/addPurchaseOrder'
    ],
    'addReplaceOrder': [
        '/authorPurchase',
        '/addReplaceOrder'
    ],
    'addFlexibleLaborOrder': [
        '/authorPurchase',
        '/addFlexibleLaborOrder'
    ],
    'addPublicTransfer': [
        '/authorPurchase',
        '/addPublicTransfer'
    ],
    'addPrivateTransfer': [
        '/authorPurchase',
        '/addPrivateTransfer'
    ],
    'purchaseOrderDetails': [
        '/authorPurchase',
        '/purchaseOrderDetails'
    ],
    'replaceOrderDetails': [
        '/authorPurchase',
        '/replaceOrderDetails'
    ],
    'flexibleLaborOrderDetails': [
        '/authorPurchase',
        '/flexibleLaborOrderDetails'
    ],
    'publicTransferDetails': [
        '/authorPurchase',
        '/publicTransferDetails'
    ],
    'privateTransferDetails': [
        '/authorPurchase',
        '/privateTransferDetails'
    ]
};

export const externalOrderPaths = [
    '/throwInManage/outerOrder/authorPurchase',
    '/throwInManage/outerOrder/authorPurchase/addAuthorPurchase',
    '/throwInManage/outerOrder/authorPurchase/authorPurchaseDetails',
    '/throwInManage/outerOrder/adFeed',
    '/throwInManage/outerOrder/adFeed/addAdFeed',
    '/throwInManage/outerOrder/adFeed/adFeedDetails',
    '/throwInManage/outerOrder/adFeed/adFeedConsumeDetails',
    '/throwInManage/outerOrder/hardHiro',
    '/throwInManage/outerOrder/hardHiro/addHardHiro',
    '/throwInManage/outerOrder/hardHiro/hardHiroDetails',
    '/throwInManage/outerOrder/authorPutin',
    '/throwInManage/outerOrder/subAccountRecharge',
    '/throwInManage/outerOrder/subAccountRecharge/details',
    '/throwInManage/outerOrder/saleRebate',
    '/throwInManage/outerOrder/saleRebate/addSaleRebate',
    '/throwInManage/outerOrder/saleRebate/saleRebateDetails'
];

export const externalOrderRouters = [
    {
        path: '/throwInManage/outerOrder/authorPurchase',
        name: 'outer_order_author_purchase',
        meta: {
            title: '达人采买代下单'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/outerOrder/authorPurchase/index.vue'),
        children: []
    }, {
        path: '/throwInManage/outerOrder/authorPutin',
        name: 'outer_order_author_putin',
        meta: {
            title: '达人投放信息'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/outerOrder/authorPutin/index.vue'),
        children: []
    }, {
        path: '/throwInManage/outerOrder/adFeed',
        name: 'outer_order_ad_feed',
        meta: {
            title: '广告投流代下单'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/outerOrder/adFeed/index.vue'),
        children: []
    }, {
        path: '/throwInManage/outerOrder/subAccountRecharge',
        name: 'outer_order_sub_account_recharge',
        meta: {
            title: '子账号充值'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/outerOrder/subAccountRecharge/index.vue'),
        children: []
    }, {
        path: '/throwInManage/outerOrder/hardHiro',
        name: 'outer_order_hard_hiro',
        meta: {
            title: '硬广代下单'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/outerOrder/hardHiro/index.vue'),
        children: []
    }, 
    {
        path: '/throwInManage/outerOrder/saleRebate',
        name: 'outer_order_sale_rebate',
        meta: {
            title: '销售返点'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/outerOrder/saleRebate/index.vue'),
        children: []
    }
];